export type UmamiEventData = Record<string, string | number | boolean | null>;

type UmamiTracker = {
  track: (event: string, data?: UmamiEventData) => void;
  identify: (id: string, data?: UmamiEventData) => void;
};

declare global {
  interface Window {
    umami?: UmamiTracker;
  }
}

/**
 * Envoie un événement à Umami. Sans effet si le script n'est pas chargé
 * (bloqueur de publicités, variables VITE_UMAMI_* absentes, Do Not Track).
 */
export const trackEvent = (event: string, data?: UmamiEventData): void => {
  window.umami?.track(event, data);
};
